export default __webpack_public_path__ + "static/media/video-camera.6e8441b8.svg";